import classnames from 'classnames';
import React, { LabelHTMLAttributes } from 'react';

const CSS = require('./Label.module.scss');

interface LabelProps extends LabelHTMLAttributes<any> {
  children: React.ReactNode;
}

function Label({ children, className, ...rest }: LabelProps) {
  const classes = classnames(CSS.Label, { [className]: className });
  return (
    <label className={classes} {...rest}>
      {children}
    </label>
  );
}

export default Label;
